<template>
    <div v-redirect-if-no-permission:CASH_REGISTER>
        <v-card>
            <v-card-title color="primary">
                <h1 style="text-align: center;margin: auto;font-size: 75px">
                    <span style="color: #49bd98">{{this.balance}}</span><span style="color: #55ddb2"> S.P</span>
                </h1>
            </v-card-title>
            <v-divider></v-divider>
            <cash-register-events :cash_register_id="cash_register_id"
                                  @new_event="handleNewEvent"></cash-register-events>
        </v-card>
    </div>
</template>

<script>
    import CashRegisterEvents from './Events';

    export default {
        name: "CashRegister",
        components: {CashRegisterEvents},
        data() {
            return {
                balance: 0
            }
        },
        computed: {
            cash_register_id() {
                return parseInt(this.$route.params.id);
            }
        },
        methods: {
            handleNewEvent(event_type, amount) {
                if (event_type === 'CREDIT' || event_type === 'CREDIT_CAPTAIN_WALLET')
                    this.balance = parseInt(this.balance) + parseInt(amount);
                else this.balance = parseInt(this.balance) - parseInt(amount);
            }
        },
        mounted() {
            this.axios.get(`cash_registers/${this.cash_register_id}`)
                .then(res => this.balance = res.data.data.balance)
                .catch(err => console.log(err.message));
        }
    }
</script>

<style scoped>

</style>